<template>
    <v-img
      :height="`${this.windowHeight}`"
      :src="require('@/assets/background/5.jpg')">
      <v-container fill-height fluid pa-0>
        <v-layout align-center justify-center>
          <v-card class="text-xs-center white--text" color="#000000dd" flat height="100%" width="40%">
            <v-container fill-height fluid pa-0>
              <v-layout align-content-center justify-center column>
                <v-flex xs2 sm2 md2 lg2></v-flex>
                <v-flex xs2 sm2 md2 lg2>
                  <v-card-text class="text-xs-center">
                    <p class="display-2 mb-3 white--text font-weight-black">
                      {{ $t('contactTitle') }}
                    </p>
                  </v-card-text>
                </v-flex>
                <v-flex xs5 sm5 md5 lg5 class="pl-3 pr-3">
                  <v-container fill-height>
                    <v-layout align-center justify-center>
                      <v-card-text class="white--text--lighten subheading font-weight-bold" style="text-align:center; border: 2px solid white">
                        <p class="mt-5">{{ $t('statement1') }}<span class="title white--text font-weight-black">{{ $t('keyword1') }}</span></p>
                        <p>{{ $t('statement2') }}<span class="title white--text font-weight-black">{{ $t('keyword2') }}</span></p>
                        <p class="mb-5">{{ $t('statement3') }}<span class="title white--text font-weight-black red--text" style="border-bottom: 2px solid red">{{ $t('keyword3') }}</span></p>
                      </v-card-text>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs2 sm2 md2 lg2></v-flex>
                <v-flex xs1 sm1 md1 lg1>
                  <v-card-text class="white--text subheading font-weight-bold mb-3" style="text-align:center;">
                    <p>EMAIL: <span class="grey--text">info@gmail.com</span>  &nbsp;|&nbsp; TEL: <span class="grey--text">123-456-7890</span></p>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card class="text-xs-center white--text" color="#000000bf" flat height="100%" width="60%">
            <v-container fill-height fluid pa-0>
              <v-layout align-content-center justify-center column>
                <v-flex xs4 sm4 md4 lg4></v-flex>
                <v-flex xs5 sm5 md5 lg5>
                  <v-card-text class="white--text" style="text-align:center;">
                    <v-form ref="contactForm" class="pl-3 pr-3">
                    <v-text-field dark
                      v-model="inputName"
                      :label="$t('contactFormName')"
                      :rules="inputRules"
                      color="light-blue lighten-3"/>
                    <v-text-field dark
                      v-model="inputEmail"
                      :label="$t('contactFormEmail')"
                      :rules="inputRules"
                      color="light-blue lighten-3"/>
                    <v-text-field dark
                      v-model="inputSubject"
                      :label="$t('contactFormSubject')"
                      :rules="inputRules"
                      color="light-blue lighten-3"/>
                    <v-textarea dark
                      v-model="inputMessage"
                      :label="$t('contactFormMessage')" counter="200"
                      :rules="inputRules"
                      color="light-blue lighten-3">
                    </v-textarea>
                  </v-form>
                  </v-card-text>
                  <v-card-actions class="pa-0">
                    <v-layout align-center justify-center>
                      <v-btn color="grey lighten-4" large @click="submitForm()" :loading="submitLoading">
                        <span class="font-weight-bold">{{ $t('contactBtn') }}</span>
                      </v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-flex>
                <v-flex xs2 sm2 md2 lg2></v-flex>
                <v-flex xs1 sm1 md1 lg1>
                  <v-card-text class="white--text subheading font-weight-bold mb-3" style="text-align:center;">
                    <p>ADDRESS: <span class="grey--text">263, Jalan Damai 4/2, Taman Damai 09400, Padang Serai, Kedah.</span></p>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-layout>
      </v-container>
      <v-snackbar
        class="mb-5"
        v-model="snackbar.value"
        :color="snackbar.color"
        :timeout="snackbar.timeout" >
        {{ snackbar.text }}
        <v-btn small dark flat @click="snackbar.value = false"> Close </v-btn>
      </v-snackbar>
    </v-img>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      windowHeight: 1000,
      inputName: '',
      inputEmail: '',
      inputSubject: '',
      inputMessage: '',
      submitLoading: false,
      inputRules: [
        v => !!v || this.$i18n.t('contactValidate')
      ],
      snackbar: {
        value: false,
        color: 'success',
        timeout: 6000,
        text: '',
      },
    }
  },

  methods: {
    ...mapActions('contact', ['storeFeedback']),

    setSize () {
      this.windowHeight = window.innerHeight
    },
    
    submitForm() {
      if (this.$refs.contactForm.validate()) {
        this.submitLoading = true
        let form = {
          email: this.inputEmail,
          name: this.inputName,
          subject: this.inputSubject,
          message: this.inputMessage
        }
        this.storeFeedback(form)
          .then(response => {
            this.successStatus()
          }).catch(error => {
            this.failStatus()
            console.log(error)
          })
      }
    },

    successStatus() {
      this.submitLoading = false
      this.snackbar.text = "Contact sent successfully."
      this.snackbar.color = "success"
      this.snackbar.value = true
      this.$refs.contactForm.reset()
      this.inputName = ''
      this.inputEmail = ''
      this.inputSubject = ''
      this.inputMessage = ''
    },

    failStatus() {
      this.submitLoading = false
      this.snackbar.text = "Please enter all details or something went wrong."
      this.snackbar.color = "error"
      this.snackbar.value = true
    }
  },

  mounted () {
    this.setSize()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue